import { IMAGES_CDN_URL } from "@/config/constants.ts";
import { getEventConditionalMapAssetFragments } from "@/event";

export const getMapAssets = (): Record<
	string,
	{ uncompressed: string; compressed: string; atlas?: string }
> => {
	return {
		"exploration-icon": {
			uncompressed: `${IMAGES_CDN_URL}/icons/exploration/mini-heal-1.png`,
			compressed: `${IMAGES_CDN_URL}/icons/exploration/mini-heal-1.pvr`,
		},
		"exploration-icon-final": {
			uncompressed: `${IMAGES_CDN_URL}/icons/exploration/mini-heal-2.png`,
			compressed: `${IMAGES_CDN_URL}/icons/exploration/mini-heal-2.pvr`,
		},
		"main-settlement-name-ribbon": {
			uncompressed: `${IMAGES_CDN_URL}/town-name-ribbon-texture.png`,
			compressed: `${IMAGES_CDN_URL}/town-name-ribbon-texture.pvr`,
		},
		"tile-selector": {
			uncompressed: `${IMAGES_CDN_URL}/tile-selector.avif?v=1`,
			compressed: `${IMAGES_CDN_URL}/tile-selector.pvr?v=1`,
		},
		"exploration-icons": {
			uncompressed: `${IMAGES_CDN_URL}/icons/exploration/all-resources-icons-180px_v3.avif`,
			compressed: `${IMAGES_CDN_URL}/icons/exploration/all-resources-icons-180px.pvr`,
		},
		"toast-end-left": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/toast-end-1-left.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/toast-end-1-left.pvr`,
		},
		"toast-end-right": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/toast-end-1-right.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/toast-end-1-right.pvr`,
		},
		"tutorial-label-bg-texture": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/textures/marble-texture-bg.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/textures/marble-texture-bg.pvr`,
		},
		"tutorial-label-arrow-down": {
			uncompressed: `${IMAGES_CDN_URL}/icons/tile/tooltip-arrow-down.avif`,
			compressed: `${IMAGES_CDN_URL}/icons/tile/tooltip-arrow-down.pvr`,
		},
		"tile-label-sprite-1": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-1.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-1.pvr`,
			atlas: `${IMAGES_CDN_URL}/backgrounds/tile-label-1.json?v2`,
		},
		"tile-label-sprite-2": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-2.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-2.pvr`,
			atlas: `${IMAGES_CDN_URL}/backgrounds/tile-label-2.json?v2`,
		},
		"tile-label-sprite-31": {
			uncompressed: `${IMAGES_CDN_URL}/events/easter/backgrounds/tile-label-31.avif`,
			compressed: `${IMAGES_CDN_URL}/events/easter/backgrounds/tile-label-31.pvr`,
			atlas: `${IMAGES_CDN_URL}/events/easter/backgrounds/tile-label-31.json`,
		},
		"tile-label-sprite-5": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-5.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-5.pvr`, // TODO: treba este skonvertovat
		},
		// fight system lable
		"tile-label-sprite-101": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-1.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-1.pvr`, // TODO: treba este skonvertovat
		},
		"tile-label-sprite-102": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-2.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-2.pvr`, // TODO: treba este skonvertovat
		},
		"tile-label-sprite-103": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-3.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-3.pvr`, // TODO: treba este skonvertovat
		},
		"tile-label-sprite-104": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-4.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/fight-system/TOOLTIP-bg-4.pvr`, // TODO: treba este skonvertovat
		},
		"tile-label-sprite-32": {
			uncompressed: `${IMAGES_CDN_URL}/events/halloween/backgrounds/tile-label-32.avif`,
			compressed: `${IMAGES_CDN_URL}/events/halloween/backgrounds/tile-label-32v2.pvr`,
			atlas: `${IMAGES_CDN_URL}/events/halloween/backgrounds/tile-label-32v2.json`,
		},
		"tile-label-sprite-33": {
			uncompressed: `${IMAGES_CDN_URL}/events/pirates/backgrounds/tile-label-33.avif`,
			compressed: `${IMAGES_CDN_URL}/events/pirates/backgrounds/tile-label-33v2.pvr`,
			atlas: `${IMAGES_CDN_URL}/events/pirates/backgrounds/tile-label-33v2.json`,
		},
		"tile-label-sprite-4": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-4.avif?v2`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/tile-label-4.pvr`,
			atlas: `${IMAGES_CDN_URL}/backgrounds/tile-label-4.json?v2`,
		},
		"close-btn": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/btn-x-100px.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/btn-x-100px.pvr`,
		},
		"i-btn": {
			uncompressed: `${IMAGES_CDN_URL}/backgrounds/btn-i-100px.avif`,
			compressed: `${IMAGES_CDN_URL}/backgrounds/btn-i-100px.pvr`,
		},
		...getEventConditionalMapAssetFragments(),
	};
};
